<app-loader-circles *ngIf="showLoader"></app-loader-circles>

<div class="row content-container">
  <form [formGroup]="dadosClienteForm" class="forms">
    <div class="row info-container white-box">
      <h2>Informações do Cliente</h2>

      <div class="form-group">
        <span class="icon documento"></span>

        <div class="inputs">
          <div class="d-inline-flex">
            <label for="cpf">CPF do Cliente</label>

            <div class="mt-n3">
              <saiba-mais
                [isPopoverOnHover]="true"
                [isPositionStatic]="true"
                [isSmall]="true"
                texto="Informe o CPF do cliente, contendo 11 números. Não é necessário inclusão de pontos ou traço."
              ></saiba-mais>
            </div>
          </div>

          <input
            class="form-control"
            type="text"
            placeholder="000.000.000-00"
            mask-number
            [mask]="'999.999.999-99'"
            appCpfValidator
            appShowErrorMessages
            requiredMessage="O campo CPF é obrigatório"
            formControlName="cpf"
            name="cpf"
            disabled
          />
        </div>
      </div>

      <div class="form-group">
        <span class="icon conjuge"></span>

        <div class="inputs">
          <label for="nomeCliente">Nome</label>
          <input
            class="form-control"
            type="text"
            placeholder="Nome do cliente"
            maxlength="60"
            required
            appShowErrorMessages
            requiredMessage="O campo Nome é obrigatório"
            formControlName="nomeCliente"
            name="nomeCliente"
          />
          <div *ngIf="showMensagemNomeCliente" class="text-danger">Informação inválida, números não são permitidos.</div>

          <div class="d-inline-flex mt-15">
            <label for="dataNascimento">Data de Nascimento</label>

            <div class="mt-n3">
              <saiba-mais
                [isPopoverOnHover]="true"
                [isPositionStatic]="true"
                [isSmall]="true"
                texto="Informe a data de nascimento do cliente, através de números do formato DD/MM/AAAA."
              ></saiba-mais>
            </div>
          </div>

          <input
            class="form-control"
            type="text"
            mask-number
            [mask]="'99/99/9999'"
            placeholder="00/00/0000"
            required
            appDataValidator
            [dateRange]="dataRange"
            appShowErrorMessages
            requiredMessage="O campo Data de Nascimento é obrigatório"
            formControlName="dataNascimento"
            name="dataNascimento"
          />
        </div>
      </div>

      <div class="form-group">
        <span class="icon email"></span>
        <div class="inputs">
          <label for="user-email">Email</label>
          <input
            maxlength="100"
            type="text"
            class="form-control"
            id="user-email"
            placeholder="email@exemplo.com.br"
            required
            formControlName="email"
            appEmailValidator
            appShowErrorMessages
            requiredMessage="Email do Cliente é obrigatório"
          />
        </div>
      </div>

      <div class="form-group">
        <span class="icon celular-cliente"></span>
        <div class="inputs">
          <label for="telefonesCliente">Celular</label>
          <input
            class="form-control"
            type="text"
            placeholder="(00) 00000-0000"
            required
            minlength="14"
            maxlength="15"
            appShowErrorMessages
            requiredMessage="O campo celular é obrigatório!"
            formControlName="telefoneCelularCliente"
            name="telefoneCelularCliente"
            appOnlyNumberRestrictive
            appDDDtelefone
            [value]="
              dadosClienteForm.get('telefoneCelularCliente').value | telefone
            "
            autocomplete="off"
          />
        </div>
      </div>

      <div class="form-group biometria">
        <span
          class="icon seguranca"
          [ngStyle]="{ 'width.px': hasBiometria ? 70 : 120 }"
        ></span>
        <div class="text">
          <span class="title">Verificação de Privacidade e Biometria</span>
          <div class="subtitle" *ngIf="hasBiometria">
            <span class="icon thumbs-up"></span>
            <span>Cliente já realizou a verificação!</span>
          </div>
          <div class="subtitle" *ngIf="!hasBiometria">
            <span class="icon thumbs-down"></span>
            <span class="ml-10">Cliente não realizou a verificação ainda!</span>
            <div class="resend-btn">
              <a
                class="bt-back btn btn-border-orange"
                (click)="resendSMS()"
                [ngClass]="{ disabled: !resendCodeEnable }"
              >
                <i class="fa fa-envelope"></i>
                <span *ngIf="resendCodeEnable"> Reenviar Link </span>
                <span *ngIf="!resendCodeEnable">
                  Reenviar em
                  <countdown
                    #countdown
                    [config]="{ leftTime: countdownTime, format: 'ss' }"
                    (event)="handleCountdownEvent($event)"
                  ></countdown
                  >s
                </span>
              </a>
              <a class="modal-anchor" (click)="openNotReceivedModal()"
                >O cliente não recebeu o link?</a
              >
            </div>
          </div>
          <div class="warning" *ngIf="!hasBiometria">
            <span class="icon warning"></span>
            <div class="text">
              <span class="text-orange">ATENÇÃO:</span> Precisamos garantir que
              o cliente confirme as permissões de LGPD, SCR e tire uma foto do
              seu rosto (selfie). <br /><span class="text-red">
                Esta etapa é obrigatória e não será possível finalizar a
                proposta sem as autorizações e foto do cliente.</span
              >
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <span class="icon citizenship"></span>
        <div class="inputs">
          <label for="user-citizenship">Nacionalidade</label>
          <select
            *ngIf="!isLoadingNacionalidadeCliente"
            id="user-citizenship"
            class="form-control"
            name="nacionalidadeCliente"
            formControlName="nacionalidade"
            required
            autocomplete="off"
            [attr.autocomplete]="false"
          >
            <option value="" selected hidden>Selecione...</option>
            <option
              *ngFor="let nc of listaNacionalidadeCliente"
              value="{{ nc.id }}"
            >
              {{ nc.descricao }}
            </option>
          </select>
          <span *ngIf="isLoadingNacionalidadeCliente">
            <i class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></i>
            Carregando...</span
          >
        </div>
      </div>

      <div class="form-group">
        <span class="icon genero"></span>
        <div class="inputs">
          <label for="sexoCliente">Gênero</label>
          <select
            class="form-control"
            required
            appShowErrorMessages
            requiredMessage="O campo Gênero é obrigatório"
            name="sexoCliente"
            formControlName="sexoCliente"
          >
            <option value="" selected hidden>Selecione...</option>
            <option value="F">FEMININO</option>
            <option value="M">MASCULINO</option>
          </select>
        </div>
      </div>

      <div class="form-group">
        <span class="icon estado-civil"></span>
        <div class="inputs">
          <label for="estadoCivilCliente">Estado Civil</label>
          <select
            class="form-control"
            required
            appShowErrorMessages
            requiredMessage="O campo Estado Civil é obrigatório"
            name="estadoCivilCliente"
            formControlName="estadoCivilCliente"
          >
            <option value="" selected hidden>Selecione...</option>
            <option
              *ngFor="let estadoCivil of estadosCivis"
              value="{{ estadoCivil.codigo }}"
            >
              {{ estadoCivil.descricao }}
            </option>
          </select>
        </div>
      </div>

      <app-dados-profissionais
        [(ngModel)]="dadoProfissional"
        [ngModelOptions]="{ standalone: true }"
        #dadosProfissionaisComponent
        name="dadosProfissionais"
        ngDefaultControl
      >
      </app-dados-profissionais>

      <div class="form-group">
        <span class="icon dinheiro"></span>
        <div class="inputs">
          <div class="d-inline-flex">
            <label for="renda">Renda</label>
            <div class="mt-n3">
              <saiba-mais
                [isPopoverOnHover]="true"
                [isPositionStatic]="true"
                [isSmall]="true"
                [texto]="
                  'Informe a renda que o cliente possui. Lembre-se que pode ser solicitado comprovação desta renda. ' +
                  'Para rendas não comprovadas, não esqueça de marcar o campo Renda Atribuída.'
                "
              ></saiba-mais>
            </div>
          </div>

          <input
            class="form-control"
            type="text"
            placeholder="R$ 00.000,00"
            required
            maxlength="17"
            appShowErrorMessages
            requiredMessage="O campo Renda é obrigatório"
            formControlName="renda"
            name="renda"
            mask-money
            [prefix]="'R$'"
            appMoedaValidator
            valorMinimoMessage="Valor mínimo permitido R$"
            appOnlyNumberRestrictive
            [valorRendaMinima]="this.parametroRendaProduto.valorRendaMinima"
          />
        </div>
      </div>

      <div class="form-group">
        <span class="icon politico"></span>
        <div class="inputs">
          <label for="cargoPoliticoCliente">Politicamente Exposto?</label>
          Exerceu cargo político nos últimos 5 anos ou é parente de algum?
          <div>
            <div class="check-mod">
              <label class="" for="isPoliticamenteExposto">
                <input
                  type="radio"
                  name="isPoliticamenteExposto"
                  formControlName="isPoliticamenteExposto"
                  value="true"
                />
                <span class="radio-label pr-20">Sim</span>
                <input
                  type="radio"
                  name="isPoliticamenteExposto"
                  formControlName="isPoliticamenteExposto"
                  value="false"
                  selected
                />
                <span class="radio-label">Não</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <span class="icon politico"></span>
        <div class="inputs">
          <label for="fatca-titulo" class="mb-8"
            >FATCA</label
          >
          Você possui obrigação fiscal com os Estados Unidos da América ou seus territórios?
          <div class="mt-12">
            <div class="check-mod">
              <label for="fatca">
                <input
                  type="radio"
                  name="fatca"
                  formControlName="fatca"
                  value="S"
                />
                <span class="radio-label pr-20">Sim</span>
                <input
                  type="radio"
                  name="fatca"
                  formControlName="fatca"
                  value="N"
                  selected
                />
                <span class="radio-label">Não</span>
              </label>
            </div>
          </div>
        </div>
      </div>
      
      <div class="form-group">
        <span class="icon celular"></span>
        <div class="inputs">
          <label for="telefonesCliente">Telefones Adicionais</label>
          <app-telefone-base
            [adicional]="true"
            [detalhesClienteForm]="dadosClienteForm"
            [needsConfirmation]="false"
            [isRemovable]="false"
          >
          </app-telefone-base>
          <div
            class="add-dado"
            (click)="addTelefone()"
            [ngClass]="{ 'disable-add': telefones.length >= 2 }"
          >
            <p><i class="fa fa-plus"></i> Adicionar telefone</p>
          </div>
          <app-telefone-base
            [adicional]="true"
            [detalhesClienteForm]="dadosClienteForm"
            [needsConfirmation]="false"
            [isRemovable]="tel == telefones.length - 1"
            [index]="tel"
            (telefoneDestroyEventEmitter)="removeTelefone($event)"
            *ngFor="let tel of telefones"
          ></app-telefone-base>
        </div>
      </div>
      <div class="form-group">
        <span class="icon pessoas"></span>
        <div class="inputs">
          <label for="referenciasCliente">Referências</label>
          <app-referencia-base
            [detalhesClienteForm]="dadosClienteForm"
            [isRemovable]="false"
          ></app-referencia-base>
          <div class="importante-info">
            <strong>Importante:</strong> precisamos de um número de contato
            direto com a referência para agilizar o processo.
          </div>
          <div
            class="add-dado"
            (click)="addReferencia()"
            [ngClass]="{ 'disable-add': filterReferencias().length >= 1 }"
          >
            <p><i class="fa fa-plus"></i> Adicionar referência</p>
          </div>
          <app-referencia-base
            [detalhesClienteForm]="dadosClienteForm"
            [index]="ref"
            [isRemovable]="true"
            (referenciaDestroyEventEmitter)="removeReferencia($event)"
            *ngFor="let ref of filterReferencias()"
          >
          </app-referencia-base>
        </div>
      </div>
    </div>
  </form>
</div>

<app-botao-navegacao
  (previous)="onClickPrevious()"
  (next)="onClickNext()"
  [nextEnabled]="isFormValid && nomeClienteValido"
></app-botao-navegacao>
